export const CHALLENGE_SCHEMA_VERSION = 1;

export interface SimpleProgressCriterionData {
  type: 'simple_progress';
  label: string;
  current: number;
  target: number;
  unit?: string | null;
}

export interface TrendMetricCriterionData {
  type: 'trend_metric';
  label: string;
  timeframe?: string;
  baseline: number;
  current: number;
  target: number;
  delta_label?: string;
  trend: number[];
}

export interface UnknownCriterionData {
  type: string;
  [key: string]: unknown;
}

export type ChallengeCriterion =
  | SimpleProgressCriterionData
  | TrendMetricCriterionData
  | UnknownCriterionData;

export interface ChallengeStatus {
  schema_version: number;
  title: string;
  subtitle?: string | null;
  icon: string;
  description?: string;
  criteria: ChallengeCriterion[];
}

export interface Challenge {
  id: string;
  location_id: string;
  is_active: boolean;
  status: ChallengeStatus;
}

export interface ChallengesResponse {
  challenges: Challenge[];
}

export const isSimpleProgress = (
  c: ChallengeCriterion,
): c is SimpleProgressCriterionData => c.type === 'simple_progress';

export const isTrendMetric = (
  c: ChallengeCriterion,
): c is TrendMetricCriterionData => c.type === 'trend_metric';
